const observers = new WeakMap();
const handlers = new WeakMap();

export default {
  inserted(el, binding) {
    const update = () => {
      const overflowed = el.scrollWidth > el.clientWidth;
      const atStart = el.scrollLeft <= 0;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

      const target = el.parentElement || el;
      target.classList.toggle('has-overflow', overflowed);
      target.classList.toggle('is-at-start', !overflowed || atStart);
      target.classList.toggle('is-at-end', !overflowed || atEnd);

      if (typeof binding.value === 'function') {
        binding.value({ overflowed, atStart, atEnd });
      }
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);
    Array.from(el.children).forEach((c) => observer.observe(c));

    el.addEventListener('scroll', update, { passive: true });

    observers.set(el, observer);
    handlers.set(el, update);
  },
  componentUpdated(el) {
    const observer = observers.get(el);
    const update = handlers.get(el);
    if (!observer) return;

    observer.disconnect();
    observer.observe(el);
    Array.from(el.children).forEach((c) => observer.observe(c));

    if (update) update();
  },
  unbind(el) {
    const observer = observers.get(el);
    const update = handlers.get(el);

    if (observer) observer.disconnect();
    if (update) el.removeEventListener('scroll', update);

    observers.delete(el);
    handlers.delete(el);
  },
};
